import { render, staticRenderFns } from "./productOrderFillBox.vue?vue&type=template&id=2df7d4a5&"
import script from "./productOrderFillBox.vue?vue&type=script&lang=js&"
export * from "./productOrderFillBox.vue?vue&type=script&lang=js&"
import style0 from "./productOrderFillBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports